import { SYSTEM_TYPES } from "@/domains/profile/constants/system-types";
import { getFieldFormatter } from "./field-types";

export function ProfileFieldModel(data) {
    if (data._formatted) return data;

    const {
        id,
        name,
        type,
        required,
        mobile,
        available,
        contract,
        size,
        new_line,
        is_system,
        profile_field_id,
        own_variants,
        save_own_variants,
        blocked,
    } = data;

    const isSystem = !!is_system;
    const fieldType = isSystem ? profile_field_id : type;

    const formatter = getFieldFormatter(isSystem, fieldType);

    const additionalData = formatter && typeof formatter.client === "function" ? formatter.client(data) : {};

    let dictionaryCode = null;
    if (isSystem) {
        dictionaryCode = SYSTEM_TYPES[fieldType].dictionaryCode;
    }

    const model = {
        _formatted: true,
        isSystem,
        blocked: !!blocked,
        id,
        name,
        fieldType,
        required: !!required,
        mobile: !!mobile,
        available: !!available,
        contract: !!contract,
        size,
        newLine: new_line === 1,
        custom: own_variants,
        saveCustom: save_own_variants,
        parentId: `${profile_field_id}`,

        dictionaryCode,

        ...additionalData,
    };

    return model;
}

export function formatProfileFieldModel(data) {
    const { id, name, fieldType, required, mobile, available, contract, size, isSystem, custom, saveCustom } = data;

    const formatter = getFieldFormatter(isSystem, fieldType);
    const additionalData = formatter && typeof formatter.server === "function" ? formatter.server(data) : {};

    const params = {
        id,
        name,
        type: fieldType,
        required: required ? 1 : 0,
        mobile: mobile ? 1 : 0,
        available: available ? 1 : 0,
        contract: contract ? 1 : 0,
        size,
        own_variants: custom ? 1 : 0,
        save_own_variants: saveCustom ? 1 : 0,

        ...additionalData,
    };

    if (isSystem) {
        params.profile_field_id = fieldType;
    }

    return params;
}
